import * as Sentry from '@sentry/react'

// Vendor-neutral client telemetry seam — the frontend twin of the server-side
// Telemetry module. track() drops a Sentry breadcrumb and fires a best-effort
// beacon to our OWN backend (no third-party analytics SDK, so kids' usage never
// leaves our infra). It never throws: instrumentation must not break the UI.
//
// Event names are namespaced "ui.*" (the backend rejects anything else). Identity
// is NOT sent — the server attributes the event to the signed-in session.

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

export function track(name, props = {}) {
  try {
    Sentry.addBreadcrumb({ category: 'telemetry', message: name, data: props, level: 'info' })
  } catch { /* breadcrumbs are decoration */ }

  try {
    const token = csrfToken()
    if (!token) return // no session context to post under; skip quietly
    // keepalive lets the request outlive a page navigation (e.g. a click that
    // routes away), which sendBeacon can't do with a CSRF header.
    fetch('/telemetry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token },
      body: JSON.stringify({ name, props }),
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => { /* best-effort */ })
  } catch { /* best-effort */ }
}
